import { resolveProp } from '@clearscore/helpers.resolve-props';

import initialNormalisedState from './initial-normalised-state';

const CHECKBOX_LIST = 'checkbox-list-filter';

export default (payload) => {
    const filters = resolveProp('applicableFilters', payload);
    if (!filters) return initialNormalisedState;
    const byId = filters.reduce((acc, filter) => {
        switch (filter.type) {
            case CHECKBOX_LIST:
                return {
                    ...acc,
                    [filter.id]: {
                        ...filter,
                        options: filter.options.map((opt) => ({
                            ...opt,
                            isApplied: !!filter.value && filter.value.includes(opt.id),
                        })),
                    },
                };
            default:
                return {
                    ...acc,
                    [filter.id]: filter,
                };
        }
    }, {});

    return {
        byId,
        allIds: [...new Set(Object.keys(byId))],
    };
};
